import type {
  IntegrationFlow,
  IntegrationGuideStepConfig,
} from "../ChannelIntegrationGuide.types";
import "./IntegrationGuideStep.css";

interface Props {
  guideSteps: IntegrationGuideStepConfig[];
  flow: IntegrationFlow;
  parentStepNumber: number;
}

const IntegrationGuideStep = ({
  guideSteps,
  flow,
  parentStepNumber,
}: Props) => {
  const visibleSteps = guideSteps.filter(
    (step) => !step.manualOnly || flow !== "oauth"
  );

  return (
    <div className="integration-guide-step">
      {visibleSteps.map((step, index) => (
        <div key={index} className="integration-guide-sub-step">
          {step.content(`${parentStepNumber}.${index + 1}`)}
        </div>
      ))}
    </div>
  );
};

export default IntegrationGuideStep;
